import { connect } from 'react-redux';
import decorate from '../../../utils/decorate';
import { List, Map } from 'immutable';

import { request as getLiabilityLimits } from '../../../modules/liabilities/actions/alerts';

import LiabilityLimits from './LiabilityLimits.jsx';

function mapStateToProps(state) {
    return {
        selections: state.liabilities.getIn([ 'limits', 'items' ]) || List(),
        status: state.liabilities.getIn([ 'limits', 'status' ], 'FINISHED' ),

        limitWarning: state.systemSettings.getIn([ 'widgetSettings', 'settings', 'liablimit_threshold' ] ) || 0,
        limitWarningStatus: state.systemSettings.getIn([ 'widgetSettings', 'state' ] ) || 'IN_PROGRESS'
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getLiabilitiesLimits() {
            dispatch(getLiabilityLimits());
        }
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    LiabilityLimits
);
